<script setup lang="ts">
import AssistantMessageLifecycle from '@/components/assistant/chat/message/AssistantMessageLifecycle.vue'
import MessageLayout from '@/components/assistant/chat/message/MessageLayout.vue'
import type {AssistantMessage, MessageProgressLifecycle} from '@/client/mentor/MessagesClient'
import {MessageProgressLifecycle as MessageProgressLifecycleEnum} from '@/client/mentor/MessagesClient'
import {computed} from 'vue'
import {useI18n} from 'vue-i18n'
import {useNow} from '@vueuse/core'

const props = defineProps<{
  isLastMessage?: boolean
  message: AssistantMessage
}>()

const {t} = useI18n()
const now = useNow({interval: 1000})

const elapsedSeconds = computed(() => (now.value.getTime() - props.message.createdAt.getTime()) / 1000)

const lastProgress = computed(() => props.message.progress?.at(-1))
const currentLifecycle = computed<MessageProgressLifecycle | undefined>(() => lastProgress.value?.lifecycle)

const pendingText = computed(() => {
  if (currentLifecycle.value === MessageProgressLifecycleEnum.RUNNING) {
    if (elapsedSeconds.value >= 25) return t('assistant.chat.message.pending.thinkingTakesLonger')
    return t('assistant.chat.message.pending.thinking')
  }

  return t('assistant.chat.message.pending.pending')
})
</script>

<template>
  <MessageLayout class="border-new-sm border-new-neutral-100 bg-new-neutral-0 print:border-none" :message="message">
    <div class="flex flex-col gap-2 text-new-neutral-700">
      <div class="text-new-secondary-default">{{ pendingText }}</div>
      <AssistantMessageLifecycle v-if="lastProgress" :progress="lastProgress" />
    </div>
  </MessageLayout>
</template>
